module.exports = __webpack_public_path__ + "static/media/09_tearsofhair.d5f7522b.jpg";